import classnames from 'classnames';

import RichText from 'molecules/RichText';
import Stats from 'molecules/Stats';
import WistiaVideoPlayer from 'molecules/Video';

import styles from 'components/Video/video.module.scss';

import { isNonEmptyArray } from 'utils/functions';

import type { VideoComponentProps } from 'components/Video/config';
import type { FeaturedTextStatsProps } from 'molecules/Stats';
import type { ComponentPropsWithoutRef, FC } from 'react';

type ComponentVideoProps = VideoComponentProps &
  Pick<FeaturedTextStatsProps, 'featuredStats'> &
  ComponentPropsWithoutRef<'section'>;

const ComponentVideo: FC<ComponentVideoProps> = ({
  backgroundColor,
  embed,
  heading,
  body,
  variant,
  featuredStats,
  ...props
}) => {
  const isContained = variant === 'contained';
  const isFullWidth = variant === 'full-width';

  const wrapperClass = classnames(styles.wrapper, {
    [styles.bkgMystic]: backgroundColor === 'blue',
  });
  const containerClass = classnames(styles.contentContainer, {
    [styles.layoutOneColumn]: isFullWidth,
    [styles.layoutTwoColumn]: isContained,
  });
  const statClasses = classnames(styles.statsContainer);

  return (
    <section className={wrapperClass} {...props}>
      <div className={containerClass}>
        <div className={styles.bodyContainer}>
          {heading && isFullWidth && <h2 className={styles.heading}>{heading}</h2>}
          {body && isContained && <RichText className={styles.bodyText} content={body} />}
          {embed && <WistiaVideoPlayer embed={embed} />}
          {isNonEmptyArray(featuredStats) && (
            <Stats featuredStats={featuredStats} className={statClasses} statClass={styles.stat} />
          )}
        </div>
      </div>
    </section>
  );
};

export default ComponentVideo;
